import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadWeek, saveWeek } from "../../lib/api/course";
import { EmptyBlank } from "../../components/common";

// import {
//   WeekInfoForm,
//   WeekStudentsForm,
//   WeekTeamsForm,
// } from "../../components/course/CourseWeekForm";

const EditWeek = () => {
  // const navigate = useNavigate();
  // const { id, week } = useParams();
  // const { weekId } = useLocation().state;

  // const [auth, setAuth] = useState();
  // const [students, setStudents] = useState([]);
  // const [teams, setTeams] = useState([]);

  // const requestCourse = useCallback(async () => {
  //   const { week } = await loadWeek({ courdId: id, week: weekId });
  //   //    setAuth(week.auth);
  //   //    setTeams(week.teams);
  // }, [id, weekId]);

  // useEffect(() => {
  //   requestCourse();
  // }, [id, requestCourse]);

  // useEffect(() => {
  //   // const course = getCourse(id);
  //   // if (course) {
  //   //   setStudents(course.students);
  //   //   setAuthCode(course.week12.auth_code);
  //   // }
  // }, [id, week]);

  // const handleChangeAuthCode = (e) => {
  //   // setAuthCode((prev) => {
  //   //   return e.target.value;
  //   // });
  // };

  // const handleChangeCourse = (e) => {
  //   const studentNumber = e.target.name;
  //   const temp = students.map((it) =>
  //     it.student_number === studentNumber
  //       ? (it.week12_course_id = e.target.value)
  //       : it
  //   );
  //   setStudents(temp);
  // };

  // const handleSave = (e) => {
  //   console.log(`${week}주차 저장`);
  //   navigate(`/course/${id}`, { replace: true });
  // };

  // const handleCancel = (e) => {
  //   console.log(`${week}주차 취소`);
  //   navigate(`/course/${id}`, { replace: true });
  // };

  // <WeekStudentsForm />
  // <WeekTeamsForm />

  return (
    <div>
      <Container fluid="md">
        <div></div>
      </Container>
    </div>
  );
};

export default EditWeek;
